import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FcSegmentModule } from '@core/components/fc-input/search-one/fc-segment-input/fc-segment-input.module';
import { CompaniesComponentModule } from '@core/components/inputs/companies/companies.module';
import { LocationsComponentModule } from '@core/components/inputs/locations/locations.module';
import { MaintenanceTypeModule } from '@core/components/inputs/maintenance-type/maintenance-type.module';
import { FuseProgressBarModule } from '@fuse/components';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { NgxMaskModule } from 'ngx-mask';
import { FcDateInputModule } from '../../../../../core/components/fc-input/base/fc-date-input/fc-date-input.module';
import { FcOutlinedInputModule } from '../../../../../core/components/fc-input/base/fc-outlined-input/fc-outlined-input.module';
import { FcTextAreaInputModule } from '../../../../../core/components/fc-input/base/fc-text-area-input/fc-text-area-input.module';
import { FcCompanyInputModule } from '../../../../../core/components/fc-input/search-one/fc-company-input/fc-company-input.module';
import { FcLocationInputModule } from '../../../../../core/components/fc-input/search-one/fc-location-input/fc-location-input.module';
import { FcMaintenanceTypeModule } from '../../../../../core/components/fc-input/search-one/fc-maintenance-type-input/fc-maintenance-type-input.module';
import { FcOutlinedSelectModule } from '../../../../../core/components/fc-select/base/fc-outlined-select/fc-outlined-select.module';
import { TabGeneralComponent } from './tab-general.component';

@NgModule({
  declarations: [
    TabGeneralComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    FuseProgressBarModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    NgxMaskModule.forRoot(),
    LocationsComponentModule,
    MaintenanceTypeModule,
    DateTimePickerModule,
    FcSegmentModule,
    FcMaintenanceTypeModule,
    FcLocationInputModule,
    FcCompanyInputModule,
    CompaniesComponentModule,
    FcTextAreaInputModule,
    FcDateInputModule,
    FcOutlinedInputModule,
    FcOutlinedSelectModule,
    PipesModule
  ],
  exports: [
    TabGeneralComponent
  ]
})
export class TabGeneralModule {


}
